export const toSlug = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')

export const fromSlug = (value: string): string => value.replace(/-/g, ' ')
